import {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconSettings,
  IconCards,
  IconTicket,
  IconUser,
  IconMessageReport,
  IconDoorEnter,
} from '@tabler/icons';
import { IconBriefcase2 } from '@tabler/icons-react';
import { companyAccountStatus, getExpiryDateFromTokenBoolean, getPermissionFromToken } from 'core/apis/common';
import i18n from 'i18n';
import { useState } from 'react';

const icons = {
  IconHome,
  IconCalendarEvent,
  IconMail,
  IconFileUpload,
  IconFileInvoice,
  IconPhoneCall,
  IconAntennaBars5,
  IconChecklist,
  IconNotebook,
  IconPhoneCheck,
  IconUsers,
  IconSettings,
  IconCards,
  IconTicket,
  IconUser,
  IconMessageReport,
  IconDoorEnter,
  IconBriefcase2
};

const employeePermissions = getPermissionFromToken();

let checkDashboard = true
const active = companyAccountStatus();
if (!active) {
  checkDashboard = false
}
const checkExpiry = getExpiryDateFromTokenBoolean();
if (checkExpiry) {
  checkDashboard = false
}

const defaultDashboard = {
  title: i18n.t('Dashboard-Menu'),
  type: 'group',
  children: [
    {
      id: 'default',
      title: i18n.t('Dashboard'),
      type: 'item',
      url: '/dashboard/default',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    employeePermissions?.includes('manageEntry') && {
      id: '01',
      title: i18n.t('Manage Entry'),
      type: 'item',
      url: '/dashboard/manageentry',
      icon: icons.IconDoorEnter,
      breadcrumbs: false
    },
    employeePermissions?.includes('allEntry') && {
      id: '02',
      title: i18n.t('All Entry'),
      type: 'item',
      url: '/dashboard/allentry',
      icon: icons.IconChecklist,
      breadcrumbs: false
    },
    employeePermissions?.includes('visitor') && {
      id: '03',
      title: i18n.t('Visitor'),
      type: 'item',
      url: '/dashboard/visitor',
      icon: icons.IconTicket,
      breadcrumbs: false
    },
    employeePermissions?.includes('appointment') && {
      id: '04',
      title: i18n.t('Appointment'),
      type: 'item',
      url: '/dashboard/appointment',
      icon: icons.IconUsers,
      breadcrumbs: false
    },
    employeePermissions?.includes('pass') && {
      id: '05',
      title: i18n.t('Pass'),
      type: 'item',
      url: '/dashboard/pass',
      icon: icons.IconCards,
      breadcrumbs: false
    },
    employeePermissions?.includes('calender') && {
      id: '06',
      title: i18n.t('Calendar'),
      type: 'item',
      url: '/dashboard/calendar',
      icon: icons.IconCalendarEvent,
      breadcrumbs: false
    },
    employeePermissions?.includes('report') && {
      id: '07',
      title: i18n.t('Report'),
      type: 'item',
      url: '/dashboard/report',
      icon: icons.IconMessageReport,
      breadcrumbs: false
    },
    employeePermissions?.includes('employee') && {
      id: '08',
      title: i18n.t('Employee'),
      type: 'item',
      url: '/dashboard/user',
      icon: icons.IconUser,
      breadcrumbs: false
    },
    employeePermissions?.includes('company') && {
      id: '09',
      title: i18n.t('Company'),
      type: 'item',
      url: '/dashboard/company',
      icon: icons.IconUser,
      breadcrumbs: false
    },
    employeePermissions?.includes('profile') && {
      id: '10',
      title: i18n.t('Profile'),
      type: 'item',
      url: '/dashboard/profile',
      icon: icons.IconSettings,
      breadcrumbs: false
    },
    employeePermissions?.includes('upgradePackage') && {
      id: '11',
      title: i18n.t('Upgrade Package'),
      type: 'item',
      url: '/dashboard/upgradepackage',
      icon: icons.IconBriefcase2,
      breadcrumbs: false
    },
    employeePermissions?.includes('companyProfile') && {
      id: '12',
      title: i18n.t('Company Profile'),
      type: 'item',
      url: '/dashboard/companyprofile',
      icon: icons.IconSettings,
      breadcrumbs: false
    },
  ]
};

const expirePackage = {
  title: i18n.t('Dashboard-Menu'),
  type: 'group',
  children: [
    {
      id: 'default',
      title: i18n.t('Dashboard'),
      type: 'item',
      url: '/dashboard/default',
      icon: icons.IconHome,
      breadcrumbs: false
    },
    employeePermissions?.includes('upgradePackage') && {
      id: '1',
      title: i18n.t('Upgrade Package'),
      type: 'item',
      url: '/dashboard/upgradepackage',
      icon: icons.IconBriefcase2,
      breadcrumbs: false
    },
    employeePermissions?.includes('companyProfile') && {
      id: '2',
      title: i18n.t('Company Profile'),
      type: 'item',
      url: '/dashboard/companyprofile',
      icon: icons.IconSettings,
      breadcrumbs: false
    },
  ]
};

const dashboard = checkDashboard ? defaultDashboard : expirePackage

export default dashboard;
